import axios from "axios";
import authHeader from "./AuthHeader";
import AuthService from "../service/AuthService";

const api_url = process.env.REACT_APP_URL;
const slug = AuthService.getLng() + "/tirebooking/cquestion/";
const bodyParameters = {};

export class QuestionService {

    getQuestions() {
        return axios
            .get(api_url + slug + "?ordering=question_order", {
                headers: authHeader(),
            })
            .then((res) => res.data.results);
    }

    getQuestion(id) {
        return axios
            .get(api_url + slug + id + "/", {
                headers: authHeader(),
            })
            .then((res) => res.data);
    }

    deleteQuestion(id) {
        return axios
            .delete(api_url + slug + `${id}/`, { headers: authHeader() })
            .then((res) => res.data.results);
    }

    createQuestion(data) {
        return axios.post(api_url + slug, bodyParameters, {
            headers: authHeader(),
            data,
        });
    }

    updateQuestion(id, data) {
        return axios.put(api_url + slug + `${id}/`, bodyParameters, {
            headers: authHeader(),
            data,
        });
    }

    getOptions() {
        return axios
            .options(api_url + slug, {
                headers: authHeader(),
            })
            .then((res) => res.data.actions.POST);
    }
}
